"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateOttMappingDto = instanceOfUpdateOttMappingDto;
exports.UpdateOttMappingDtoFromJSON = UpdateOttMappingDtoFromJSON;
exports.UpdateOttMappingDtoFromJSONTyped = UpdateOttMappingDtoFromJSONTyped;
exports.UpdateOttMappingDtoToJSON = UpdateOttMappingDtoToJSON;
exports.UpdateOttMappingDtoToJSONTyped = UpdateOttMappingDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateOttMappingDto interface.
 */
function instanceOfUpdateOttMappingDto(value) {
    return true;
}
function UpdateOttMappingDtoFromJSON(json) {
    return UpdateOttMappingDtoFromJSONTyped(json, false);
}
function UpdateOttMappingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ott_platform_id': json['ott_platform_id'] == null ? undefined : json['ott_platform_id'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'listing_url': json['listing_url'] == null ? undefined : json['listing_url'],
    };
}
function UpdateOttMappingDtoToJSON(json) {
    return UpdateOttMappingDtoToJSONTyped(json, false);
}
function UpdateOttMappingDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'ott_platform_id': value['ott_platform_id'],
        'priority': value['priority'],
        'listing_url': value['listing_url'],
    };
}
